import { IconProps } from "@/src/sb/business-layer/types"

const Copy = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.66536 10.6654C1.93203 10.6654 1.33203 10.0654 1.33203 9.33203V2.66536C1.33203 1.93203 1.93203 1.33203 2.66536 1.33203H9.33203C10.0654 1.33203 10.6654 1.93203 10.6654 2.66536M6.66536 5.33203H13.332C14.0684 5.33203 14.6654 5.92898 14.6654 6.66536V13.332C14.6654 14.0684 14.0684 14.6654 13.332 14.6654H6.66536C5.92898 14.6654 5.33203 14.0684 5.33203 13.332V6.66536C5.33203 5.92898 5.92898 5.33203 6.66536 5.33203Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Copy
